

















































































import { Component, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  DataTable,
  Col,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { CollectionFlag, SortOrder } from '@/types'
import { IconBibliography } from '@/components/molecules/IconBibliography'
import { InputCode } from '@/components/molecules/InputCode'
import { ChildCollection, SystemCode } from '@/api'
import { Emit } from '@/node_modules/nuxt-property-decorator'
import { orderBy } from 'lodash'
import { ButtonToggle } from '@/components/molecules/ButtonToggle'

const COLS: Col[] = [
  {
    width: 40,
    items: [
      {
        name: 'descNo',
        align: 'right'
      }
    ]
  },
  {
    width: '30',
    resizable: true,
    items: [
      {
        name: 'sortTitle',
        headerText: 'タイトル',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    items: [
      {
        name: 'collectionNo',
        headerText: '資料番号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '18',
    resizable: true,
    items: [
      {
        name: 'sortAuthor',
        headerText: '責任表示／年月日号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'holdingBranchCode',
        headerText: '所蔵館',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'shelfType',
        headerText: '配架',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'collectionType',
        headerText: '資料区分',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'handlingType',
        headerText: '取扱',
        sortable: true,
        sortOrder: ''
      }
    ]
  }
]

@Component({
  components: { ButtonToggle, InputCode, IconBibliography, DataTable }
})
export default class ChildCollectionListTable extends ComponentVue {
  @Prop({
    type: Number,
    required: true
  })
  height!: number

  @PropSync('items', {
    type: Array,
    required: true
  })
  tableItems!: ChildCollection[]

  sortName: string = ''

  sortOrder: SortOrder = ''

  get cols(): Col[] {
    return COLS
  }

  get sortedTableItems(): ChildCollection[] {
    if (this.sortName) {
      return orderBy<ChildCollection>(
        this.tableItems,
        (item: ChildCollection) => {
          const propertyValue = item[this.sortName as keyof ChildCollection]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (type === 'object') return (propertyValue as SystemCode).shortName

          return propertyValue
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.tableItems
  }

  initializeSort(): void {
    this.onSort({
      name: '',
      order: ''
    })
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }

  onSort(sortColumn: SortColumn): void {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  @Emit('title')
  onClickTitle(obj: {
    bibliographyId: number
    collectionNo: string
    title: string
  }): {
    bibliographyId: number
    collectionNo: string
    title: string
  } {
    return obj
  }
}
